import type { Image } from '@/types/image'

export const DEFAULT_RELATED_CONTENT_LIMIT = 20

/** 关联作品选择弹窗 - 列表项（UI 层） */
export interface RelatedWorkItem {
  displayOriginalTitle: string
  uniqueContentId: string
  /** 展示标题（由接口 displayTitle 映射） */
  title: string
  coverUrl: string
  selectable: boolean
  activeReferralCount: number
  isVideo: boolean
}

/** 关联作品候选 - 接口原始项 */
export interface RelatedWorkCandidate {
  contentId: string
  /** 封面图列表（接口字段名为 posterImage） */
  posterImage: Partial<Image>[]
  displayOriginalTitle: string
  /** 展示标题（统一取此字段） */
  displayTitle: string
  contentType: 'post' | 'video'
  selectable: boolean
  activeReferralCount: number
}

/** GET /aigc/api/topic/content/relation/candidates 响应 data */
export interface RelatedWorkCandidatesResponse {
  dataList: RelatedWorkCandidate[]
  associateLimit: number
  hasMore?: boolean
  page?: number
  pageSize?: number
  totalCount?: number
}

function resolvePostImageCoverUrl(poster: Partial<Image> | undefined, isVideo: boolean): string {
  if (!poster) return ''

  if (isVideo) {
    const frameUrl = poster.firstFrameResize512Url || poster.url || ''
    if (!frameUrl) return ''
    return frameUrl.startsWith('http')
      ? frameUrl
      : `https://mm-jjewelry-test-bj.tos-cn-beijing.volces.com/${frameUrl}`
  }

  return poster.imageResize512Url ?? poster.url ?? ''
}

export function mapCandidateToRelatedWork(item: RelatedWorkCandidate): RelatedWorkItem {
  const isVideo = item.contentType === 'video'
  const poster = item.posterImage?.[0]

  return {
    displayOriginalTitle: item.displayOriginalTitle || '',
    uniqueContentId: item.contentId,
    title: item.displayTitle || '',
    coverUrl: resolvePostImageCoverUrl(poster, isVideo),
    selectable: item.selectable,
    activeReferralCount:
      typeof item.activeReferralCount === 'number' ? item.activeReferralCount : 0,
    isVideo
  }
}

export function resolveAssociateLimit(limit?: number): number {
  return limit && limit > 0 ? limit : DEFAULT_RELATED_CONTENT_LIMIT
}
